import { Widget } from "./Widget";
import { embedWidget, questionWidget } from "../../constants/widget";

function Widgets(props) {
  function isModuleImplemented(lessonModuleName) {
    return (
      lessonModuleName !== embedWidget &&
      lessonModuleName !== questionWidget
    );
  }

  return (
    <div className="Widgets">
      {props.children}
      {props.widgets &&
        props.widgets.map((values, idx) => {
          if (isModuleImplemented(values.lesson_module_name)) {
            const _values = {...values, position: idx + 1};
            return (
              <Widget
                key={values.id}
                {...props}
                {..._values}
              />
            )
          }
        }
      )}
    </div>
  )
}

export { Widgets }
